import { createFileRoute } from '@tanstack/react-router'
import { ApiKeyDetail } from '../../../../features/admin/ApiKeyDetail'

/* ───── Route Definition ───── */

export const Route = createFileRoute(
  '/_authenticated/admin/api-keys/$id',
)({
  component: ApiKeyDetailRoute,
})

/* ───── Route Component ───── */

function ApiKeyDetailRoute() {
  const { id } = Route.useParams()
  return <ApiKeyDetail keyId={id} />
}
